const e = {
  default: "d-recipe-feed-item-pill__border--default",
  ai: "d-recipe-feed-item-pill__border--ai",
  critical: "d-recipe-feed-item-pill__border--critical"
}, i = {
  FEED_ITEM_PILL_BORDER_COLORS: e
};
export {
  e as FEED_ITEM_PILL_BORDER_COLORS,
  i as default
};
//# sourceMappingURL=feed-item-pill-constants.js.map
